// Mutation hook - edycja stopki (PATCH-style PUT).
// PUT /api/ui/sales-crm/mailbox/signatures/{id}
// Sprint 3 v4.1. Edycja htmlContent inkrementuje version (anti-lasagne marker).

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPutMailSignatureRequest,
  IPutMailSignatureResponse
} from 'api/types/signature';
import { MAIL_SIGNATURES_QUERY_KEY_BASE } from 'api/endpoints/useGetMailSignatures';

export interface IUsePutMailSignatureParams {
  id: number;
  body: IPutMailSignatureRequest;
}

const putMailSignature = (
  params: IUsePutMailSignatureParams
): Promise<IPutMailSignatureResponse> =>
  axios.put(`/sales-crm/mailbox/signatures/${params.id}`, params.body);

export const usePutMailSignature = (
  options?: UseMutationOptions<IPutMailSignatureResponse, IError, IUsePutMailSignatureParams>
) => {
  const queryClient = useQueryClient();
  return useMutation<IPutMailSignatureResponse, IError, IUsePutMailSignatureParams>(
    putMailSignature,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries([MAIL_SIGNATURES_QUERY_KEY_BASE]);
        options?.onSuccess?.(data, variables, context);
      }
    }
  );
};
